<script lang="ts">
import NewIssueCell from '@/presentation/pages/resources/cells/NewIssueCell.vue';

export default {
  name: 'NewIssueColumn',
  components: { NewIssueCell },
};
</script>

<template>
  <Column field="plant.new_issue" style="width: 11rem">
    <template #header>
      {{ $t('features.filtering.names.issues_new') }}
      <help-icon
        :title="$t('glossary.issue', 2)"
        :description="$t('features.issues.help_description')"
        link="https://support.sundata.nl/nl/articles/5422569-indicatoren-uitleg"
        class="ml-1"
      />
    </template>
    <template #body="slotProps">
      <new-issue-cell :plant-json="slotProps.data.plant" />
    </template>
  </Column>
</template>

<style scoped></style>
